import { render } from "./EvidencesView.vue?vue&type=template&id=b8e49628&scoped=true"
import script from "./EvidencesView.vue?vue&type=script&lang=js"
export * from "./EvidencesView.vue?vue&type=script&lang=js"

import "./EvidencesView.vue?vue&type=style&index=0&id=b8e49628&scoped=true&lang=css"

import exportComponent from "/home/tikam/Documents/2023/Ferat/FERAT FINAL/routerlinks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e49628"]])

export default __exports__